import React from 'react';
import { nextWindowsChecker } from '@/constants/helper';
import { Button, InternetBanner } from '@/ui/index';
import { Arrow } from '@/icons/index';
import styles from './EsimBanner.module.scss';

const EsimBanner = ({ data, blockRef }) => {
  const onClick = () => {
    if (!blockRef) return;
    const { top } = blockRef.current.getBoundingClientRect();
    if (nextWindowsChecker()) {
      window.scrollTo({ top: top - 120, behavior: 'smooth' });
    }
  };
  return (
    <InternetBanner
      bannerData={data}
      itemScope
      itemType='https://schema.org/WPAdBlock'
    >
      <div>
        <Button onClick={onClick} className={styles.button} variant={'white'}>
          Get eSIM
          <Arrow width={24} />
        </Button>
      </div>
    </InternetBanner>
  );
};

export default EsimBanner;
